import TextAreaWithTitle from "common/Inputs/TextAreaWithTitle";
import React, { useEffect } from "react";
import { FixMeLater } from "types";
import { useTheme } from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface FreeTextInputProps {
  setFreeText: (freeText: string) => void;
  onFocus?: () => void;
  freeText?: string;
  placeholder?: string;
}

const FreeTextInput = ({
  setFreeText,
  onFocus,
  freeText,
  placeholder,
}: FreeTextInputProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const theme = useTheme();
  const inputRef = React.useRef(null);

  useEffect(() => {
    (inputRef?.current as FixMeLater)?.focus();
  }, [inputRef]);

  return (
    <TextAreaWithTitle
      title={t("labels.trade_text")}
      placeholder={placeholder}
      allowClear
      onChange={(e) => setFreeText(e.target.value)}
      autoSize={{ minRows: 4, maxRows: 6 }}
      onFocus={onFocus}
      innerRef={inputRef as FixMeLater}
      value={freeText}
      wrapperStyle={{
        border: theme.borders.medium,
        borderRadius: 6,
        boxShadow: "none",
      }}
    />
  );
};

export default FreeTextInput;
